import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
import { getCurrencySymbol } from '../helper/currencies';
import { QuestStatusBarView } from '../../view/quest/QuestStatusBar';
import {
	generateBetDiscount,
	generateBonusDiscount,
	generateBonusGame,
	generateWildRespin,
	generateWinMultiplier
} from './helper/GenerateItems';

class PromptController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.interaction = true;
		AnimateEntrance(this.vc);
		if (this.vc[this.config.holder]) {
			this.wrapper = this.vc[this.config.holder];
			this.wrapper.PROMPT_YES.handler = this.handler.bind(this);
			this.wrapper.PROMPT_NO.handler = this.close.bind(this);
			this.enabled = true;
			this.reels = GameConfigs.reelComponent;
			this.currency = getCurrencySymbol(
				GameConfigs.auth.balance.currency,
				true
			);
			this.generatePrize();
			window.addEventListener(EVENTS.NOTIFICATION, this, false);
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
			}
		} else {
			throw new Error(
				'PromptController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.NOTIFICATION:
				this.close();
				window.removeEventListener(EVENTS.NOTIFICATION, this, false);
				break;
			case 'keydown':
				if (
					evt.keyCode === 27 ||
					(evt.keyCode === 32 && !GameConfigs.disabled.spin)
				) {
					if (GameConfigs.modal === 'prompt') {
						this.close();
					}
					window.removeEventListener(EVENTS.NOTIFICATION, this, false);
					window.removeEventListener('keydown', this, false);
				}
				break;
			default:
				break;
		}
	}

	generatePrize() {
		if (GameConfigs.quest_claim.item) {
			switch (GameConfigs.quest_claim.item.prize.type) {
				case 'bonus_game':
					generateBonusGame(this.wrapper, GameConfigs, this.currency);
					break;
				case 'bonus_discount':
					generateBonusDiscount(this.wrapper, GameConfigs, this.currency);
					break;
				case 'wild_respin':
					generateWildRespin(this.wrapper, GameConfigs, this.currency);
					break;
				case 'bet_discount':
					generateBetDiscount(this.wrapper, GameConfigs, this.currency);
					break;
				case 'win_multiplier':
					generateWinMultiplier(this.wrapper, GameConfigs, this.currency);
					break;
				default:
					break;
			}
		}
	}
	handler() {
		if (GameConfigs.reelComponent.rotating) return;
		if (!this.enabled) return;
		this.enabled = false;
		if (GameConfigs.doubleChance) {
			HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
				doubleChance: false
			});
		}
		HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
			quest_claim: {
				...GameConfigs.quest_claim,
				activated_item: GameConfigs.quest_claim.pending_item
			}
		});
		GameConfigs.quest_is_active = true;

		let quest_current = GameConfigs.quest_parsed.items.find(
			(item) => item.item.id === GameConfigs.quest_claim.activated_item
		);
		GameConfigs.quest_current = quest_current;
		GameConfigs.quest_current = {
			...GameConfigs.quest_current,
			claimed: GameConfigs.quest_current
				? GameConfigs.quest_current.claimed
				: GameConfigs.quest_claim.item.prize.count -
					GameConfigs.quest_claim.item.claimed
		};
		if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
			GameConfigs.uiComponent.removeView(
				GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
			);
		}
		if (GameConfigs.quest_claim.item.step) {
			GameConfigs.uiComponent.addView(QuestStatusBarView);
		}

		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		HELPERS.dispatchCustomEvent(EVENTS.BET_UPDATE, {
			betAmount: GameConfigs.config.bet_steps[GameConfigs.quest.bet_level]
		});

		this.sendBet();
	}

	close() {
		window.sm.play({ name: 'bonus_buy_quest_close_sfx' });
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		GameConfigs.quest_claim.activated_item = 0;
		GameConfigs.quest_claim.pending_item = 0;
	}

	sendBet() {
		window.connectionProvider.bet(
			JSON.stringify({
				service: 'bet',
				data: {
					amount:
						GameConfigs.config.bet_steps[
							GameConfigs.quest.bet_level
						].toString(),
					doublefeaturechance: 0,
					buybonus: 0,
					questid: GameConfigs.quest_claim.activated_item
				}
			})
		);
		HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
	}
}
export default PromptController;
